Vue.component('state-play', {
    data: function () {
        let newUpdates = false;
        try {
            let lastUpdateSeen = parseInt(Cookies.get('lastUpdateSeen'));
            if (lastUpdateSeen && lastUpdateSeen !== $('#change-log-text').data().updateCount) {
                newUpdates = true;
            }
        } catch (e) {}

        let playerName = '';
        if (window.localStorage) {
            playerName = window.localStorage.getItem('name');
        }
        if (game.services.user.currentUser) {
            playerName = game.services.user.currentUser.name.split(' ')[0];
        }

        axios.get(API_URL + '/gameStats').then((res) => {
            let data = res.data;

            this.playerCount = data.playerCount;
            this.gameCount = data.gameCount;

            let regionsKeys = Object.keys(data.regions);
            let selectedRegion = 'NA1';
            let selectedRegionDist = 100000;
            regionsKeys.sort((a, b) => {
                return a > b;
            });

            let regions = [];
            for (let i=0; i<regionsKeys.length; i++) {
                let region = data.regions[regionsKeys[i]];
                regions.push(region);
                let dist = getDistanceFromLatLonInKm(data.coords[0], data.coords[1], region.coords[0], region.coords[1]);
                if (dist < selectedRegionDist) {
                    selectedRegion = region.code;
                    selectedRegionDist = dist;
                }
            }
            this.regionOptions = regions;
            this.selectedRegion = selectedRegion;
        });

        game.services.ad.showBannerAd();

        return {
            gameCount: 0,
            playerCount: 0,
            newUpdates: newUpdates,
            currentMenu: null,
            createGameData: {
                gamemode: 'normal',
                createGame: true,
                privateGame: true
            },
            currentUser: game.services.user.currentUser,
            gameListLoading: false,
            isDevSite: window.location.host === 'dev.antwar.io',
            gameList: [],
            playerName: playerName,
            selectedRegion: 'NA1',
            isMobile: game.isMobile,
            regionOptions: [
                {
                    name: 'North America',
                    code: 'NA1',
                    coords: [40.7128, -74.006],
                    playerCount: 0,
                    gameRoomCount: 0
                }
            ]
        };
    },
    methods: {
        play: function(gamemode) {
            if (!gamemode) {
                gamemode = 'normal';
            }

            game.play(null, {
                gamemode: gamemode,
                playerName: this.playerName,
                regionCode: this.selectedRegion
            });
        },
        startSingleplayer: function(isTutorial, isSandbox) {
            game.startSingleplayer(isTutorial, isSandbox);
        },
        showGameList: function() {
            this.currentMenu = 'gameList';
            this.gameListLoading = true;
            axios.get(API_URL + '/gameList').then((res) => {
                let data = res.data;

                let games = [];
                if (data && data.games && data.games.length) {
                    games = data.games;
                    games.sort(function(a, b) {
                        return b.players - a.players;
                    });
                }

                this.gameList = games;
                this.gameListLoading = false;
            });

            ga('send', {
                hitType: 'event',
                eventCategory: 'Lobby',
                eventAction: 'openGameList'
            });
        },
        joinGame: function(selectedGame) {
            if (selectedGame) {
                if (!game.queryData) {
                    game.queryData = {};
                }

                game.queryData.invite = selectedGame.token;
                this.play();
            }
        },
        createGame: function() {
            if (this.currentUser) {
                game.play(this.createGameData, {
                    playerName: this.playerName,
                    regionCode: this.selectedRegion,
                    gamemode: this.createGameData.gamemode
                });
            }
        },
        returnToMainMenu: function() {
            this.currentMenu = null;
            game.services.ad.showBannerAd();
        },
        openChangeLog: function() {
            this.newUpdates = false;
            Cookies.set('lastUpdateSeen', $('#change-log-text').data().updateCount, {expires: 365});

            ga('send', {
                hitType: 'event',
                eventCategory: 'Lobby',
                eventAction: 'openChangeLog'
            });
        }
    },
    template: html`
    <div>
        <div class="row">
            <div class="col">
                <input v-model="playerName" class="app-input" placeholder="Name" :disabled="currentUser">
            </div>
            <div class="col">
                <select class="app-input" v-model="selectedRegion">
                    <option disabled value="">Select a Region</option>
                    <option v-for="region in regionOptions" v-bind:value="region.code">
                        {{ region.name }} ({{ region.playerCount }} Players)
                    </option>
                </select>
            </div>
        </div>
        <div v-if="!currentMenu">
            <button type="button" class="app-btn app-btn-primary" v-on:click="play('normal')">
                <i class="fa fa-play"></i> Play Competitive
            </button>
            <button type="button" class="app-btn app-btn-primary" v-on:click="play('endless')">
                <i class="fa fa-play"></i> Play Endless
            </button>
            <button type="button" class="app-btn app-btn-secondary" v-on:click="showGameList()">
                <i class="fa fa-list"></i> Game List
            </button>
            <br><br>
            <h3>{{playerCount}} Online Players | {{gameCount}} Games</h3>
            <br>
            <div class="row" v-if="!isMobile">
                <div class="col">
                    <a href="https://stug.io/?utm_source=antwar" class="stug"><img alt="Stug.io - Free multiplayer tank battles" src="/assets/stug2.gif"></a>
                    <br>
                </div>
            </div>
            <br>
            <div class="menu-box text-center" id="ad-menu">
                <div id="antwar-io_300x250" style="margin-left:auto; margin-right:auto; width:300px; height:250px;">
                    <div style="margin-bottom: -75px;">
                        <br>
                        Please disable your ad blocker.
                        <br>
                        Servers are expensive! :)
                    </div>
                </div>
                <br>
            </div>
            <div class="app-card text-center">
                <div class="row">
                    <div class="col col-1">
                        <i style="color:#be1c1c;" class="fa fa-4x fa-exclamation"></i> 
                    </div>
                    <div class="col">
                        This is the development version of AntWar.io.<br>
                        Stats/users/ranks are not permanent.<br>
                        When the game is complete everything will be reset.
                    </div>
                    <div class="col col-1">
                        <i style="color:#be1c1c;" class="fa fa-4x fa-exclamation"></i> 
                    </div>
                </div>
            </div>
            <br>
            <h2>Singleplayer</h2>
            <div class="row">
                <div class="col">
                    <button type="button" v-on:click="startSingleplayer(true, false);" class="app-card app-card-clickable text-center">
                        <img class="card-img-top" src="assets/singleplayer_tutorial.png" alt="Tutorial">
                        <div class="card-body">
                            <h4>Tutorial</h4>
                        </div>
                    </button>
                </div>
                <div class="col">
                    <button type="button" v-on:click="startSingleplayer(false, false);" class="app-card app-card-clickable text-center">
                        <img class="card-img-top" src="assets/singleplayer_skirmish.png" alt="Skirmish">
                        <div class="card-body">
                            <h4>Skirmish</h4>
                        </div>
                    </button>
                </div>
                <div class="col">
                    <button type="button" v-on:click="startSingleplayer(false, true);" class="app-card app-card-clickable text-center">
                        <img class="card-img-top" src="assets/singleplayer_sandbox.png" alt="Sandbox">
                        <div class="card-body">
                            <h4>Sandbox</h4>
                        </div>
                    </button>
                </div>
            </div>
            <br><br>
            <div class="row">
                <div class="col" v-if="newUpdates">
                    <a href="#" class="app-btn app-btn-secondary new-update-message" style="padding:12px;" v-on:click="openChangeLog();" data-toggle="modal" data-target="#changeLogModal">
                        <i class="fa fa-exclamation bounce"></i> New Updates
                    </a>
                </div>
                <div class="col" v-if="!newUpdates">
                    <a href="#" class="app-btn app-btn-secondary" style="padding:12px;" v-on:click="openChangeLog();" data-toggle="modal" data-target="#changeLogModal">
                        <i class="fa fa-list"></i> Change Log
                    </a>
                </div>
                <div class="col">
                    <a href="https://antwario.wikia.com/wiki/AntWar.io_Wiki" target="_blank" style="padding:12px;" class="app-btn app-btn-secondary">
                        <i class="fa fa-question-circle"></i> AntWar.io Wiki
                    </a>
                </div>
            </div>
        </div>
        <div v-if="currentMenu === 'gameList'">
            <br><br>
            <div v-if="gameListLoading">
                <h1><i class="fa fa-refresh fa-spin"></i></h1>
            </div>
            <div v-if="!gameListLoading">
                <h3 v-if="gameList.length <= 0">No games found.</h3>
                <div v-for="game in gameList" class="app-card app-card-clickable" v-on:click="joinGame(game)">
                    <div class="row">
                        <div class="col text-left">
                            <b>Game #{{ game.id }}</b> <i v-if="game.isPrivate" class="fa fa-lock"></i><br>
                            {{game.gamemode}} - {{ game.state === 'lobby' ? 'In Lobby' : 'Playing' }}
                        </div>
                        <div class="col pull-right text-right">
                            <b><i class="fa fa-user"></i> {{ game.players }}/{{ game.maxPlayers }}</b><br>
                            <i class="fa fa-globe"></i> {{ game.region.name }}
                        </div>
                    </div>
                </div>
            </div>
            <br>
            <button type="button" class="app-btn app-btn-secondary" v-if="currentUser" v-on:click="currentMenu='createGame';">
                <i class="fa fa-plus"></i> Create Game
            </button>
            <button type="button" class="app-btn app-btn-danger" v-on:click="returnToMainMenu()">
                <i class="fa fa-arrow-left"></i> Return
            </button>
            <br><br>
        </div>
        <div v-if="currentMenu === 'createGame'">
            <br>
            <div class="app-card text-center">
                <h1><i class="fa fa-plus"></i> Create Game</h1>
                <p>Create a new game lobby instead of joining an existing game.</p>
                <div class="row" style="margin: 20px;" v-if="currentUser && currentUser.isDev">
                    <br>
                    <div class="col-sm-1">
                        <input class="app-input"  type="checkbox" id="checkbox" v-model="createGameData.privateGame">    
                    </div>
                    <div class="col text-left">
                        <label>
                             <i class="fa fa-lock"></i> Private game?
                        </label>
                        <p>(Other players can only join a private game with an invite link but you cannot earn XP or Coins.)</p>           
                    </div>
                    <br>
                </div>
                <br>
                <div class="row">
                    <div class="col text-left">
                        <h4>Gamemode</h4>
                        <select class="app-input" v-model="createGameData.gamemode" @change="refreshMapLists()">
                            <option value="normal">Competitive</option>
                            <option value="endless">Endless</option>
                            <option value="coop">Co-Op</option>
                        </select>
                    </div>
                    <div class="col text-left">
                        <!--<h4>Settings</h4>-->
                        <br>
                    </div>
                </div>
                <p v-if="createGameData.gamemode === 'coop'">NOTE: Co-Op isn't balanced at all and is more of a test mode at the moment. Also if you block in your queen enemies will teleport to her, so don't do that.</p>
            </div>
            <button type="button" class="app-btn app-btn-secondary" v-on:click="createGame();">
                <i class="fa fa-plus"></i> Create Game
            </button>
            <button type="button" class="app-btn app-btn-danger" v-on:click="currentMenu='gameList';">
                <i class="fa fa-arrow-left"></i> Return
            </button>
            <br><br>
        </div>
        <br><br>
    </div>
    `
});

function deg2rad(degrees) {
    return degrees * Math.PI / 180;
}
function getDistanceFromLatLonInKm(lat1, lon1, lat2, lon2) {
    let R = 6371; // Radius of the earth in km
    let dLat = deg2rad(lat2-lat1);  // deg2rad below
    let dLon = deg2rad(lon2-lon1);
    let a =
        Math.sin(dLat/2) * Math.sin(dLat/2) +
        Math.cos(deg2rad(lat1)) * Math.cos(deg2rad(lat2)) *
        Math.sin(dLon/2) * Math.sin(dLon/2)
    ;
    let c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
    return R * c;
}

game.verifyName = function(name) {
    if (!name) {
        game.showGrowl('Please enter a name.', {type: 'danger'});
        return false;
    } else if (/[^a-zA-Z0-9\[\]]/.test(name)) {
        game.showGrowl('Names can only have letters and numbers.', {type: 'danger'});
        return false;
    } else if (name.length <= 2) {
        game.showGrowl('Name is too short.', {type: 'danger'});
        return false;
    } else if (name.length > 16) {
        game.showGrowl('Name is too long.', {type: 'danger'});
        return false
    }
    return true;
};

let lastPlayData = {};
game.play = function(createData, playData, token) {
    if (!playData) {
        playData = lastPlayData;
    }
    if (!playData) {
        playData = {};
    }
    lastPlayData = playData;
    let name = playData.playerName;

    if (!name && window.localStorage) {
        name = window.localStorage.getItem('name');
    }

    if (!token) {
        if (!game.verifyName(name)) {
            return;
        }
    }

    game.isTutorial = false;

    try {
        if (window.localStorage) {
            game.disableTutorialAsk = window.localStorage.getItem('disableTutorialAsk') === 'true';
        } else {
            game.disableTutorialAsk = Cookies.get('disableTutorialAsk') === 'true';
        }
    } catch (e) {
        game.disableTutorialAsk = Cookies.get('disableTutorialAsk') === 'true';
    }

    if (game.services.user.currentUser && game.services.user.currentUser.currentXp >= 1000) {
        game.disableTutorialAsk = true;
    }
    if (!game.disableTutorialAsk) {
        try {
            if (window.localStorage) {
                window.localStorage.setItem('disableTutorialAsk', 'true');
            } else {
                Cookies.set('disableTutorialAsk', game.disableTutorialAsk, {expires: 365});
            }
        } catch (e) {
            Cookies.set('disableTutorialAsk', game.disableTutorialAsk, {expires: 365});
        }

        try {
            game.startTutorial();
            return;
        } catch (e) {}
    }

    if (!createData) {
        if (!(game.queryData && game.queryData.invite) && game.services.ad.checkShowVideoAd()) {
            waitingToPlay = true;
            return;
        }
    }

    let session = '';
    if (Cookies.get('token')) {
        session = '&session=' + Cookies.get('token')
    }

    let regionCode = playData.regionCode;
    if (!regionCode) {
        regionCode = 'NA1';
    }

    let inviteQuery = '';
    if (game.queryData && game.queryData.invite) {
        inviteQuery = '&invite=' + game.queryData.invite;
    }

    let gamemodeQuery = '';
    if (playData && playData.gamemode) {
        gamemodeQuery = '&gamemode=' + playData.gamemode;
    }

    $('#loading-overlay').show();
    axios.post(API_URL + '/token?name=' + name + '&region=' + regionCode + session + gamemodeQuery + inviteQuery, createData).then((res) => {
        let data = res.data;
        if (data.success) {
            Cookies.set('lastUpdateSeen', $('#change-log-text').data().updateCount, {expires: 365});
            if (window.localStorage) {
                window.localStorage.setItem('name', name);
            }

            if (window.ga) {
                ga('send', {
                    hitType: 'event',
                    eventCategory: 'Lobby',
                    eventAction: session ? 'playAsUser' : 'playAsGuest'
                });

                if (createData && createData.privateGame) {
                    ga('send', {
                        hitType: 'event',
                        eventCategory: 'Lobby',
                        eventAction: 'createPrivateGame'
                    });
                }
            }

            game.queryData = data;
            game.startPlayScreen(false, false);
            game.init();

            $('#loading-overlay').hide();

            /*
            let playHref = 'http://' + window.location.host + '/play/?token=' + data.token + '&address=' + data.address + '&port=' + data.port;
            if (playHref.startsWith('https')) {
                playHref = playHref.replace('https', 'http');
            }

            try {
                let url = (window.location !== window.parent.location) ? document.referrer : document.location.href;
                if (url.indexOf('iogames.space') !== -1) {
                    window.location = playHref;
                } else {
                    window.parent.location = playHref;
                }
            } catch (e) {
                window.location = playHref;
            }
            */
        } else {
            game.showGrowl(data.message, {type: 'danger'});
            $('#loading-overlay').hide();
        }
    }, () => {
        game.showGrowl('Failed to connect to game server.', {type: 'danger'});
        $('#loading-overlay').hide();
    });
};

game.startTutorial = function() {
    game.disableTutorialAsk = true;
    game.startSingleplayer(true);
};

var waitingToPlay = false;
var waitingToPlaySingleplayer = null;
game.videoComplete = function() {
    if (waitingToPlay) {
        game.play();
        waitingToPlay = false;
    }

    if (waitingToPlaySingleplayer) {
        game.startSingleplayer(false, waitingToPlaySingleplayer.isSandbox);
        waitingToPlaySingleplayer = null;
    }
};

let serverConfig = null;
const messageChannel = new MessageChannel();
let webWorkerRegistered = false;
let gameWorker;
function registerWorker() {
    if (window.Worker) {
        webWorkerRegistered = true;

        gameWorker = new Worker('./serverBuilt.js');

        gameWorker.onmessage = (event) => {
            switch (event.data.type) {
                case 'disconnect':
                    window.location.reload();
                    break;
                case 'snapshot':
                    game.onSnapshot(event.data.data);
                    break;
                default:
                    if (game.fakeSockets && game.fakeSockets.clientSocket && game.fakeSockets.clientSocket.socketEvents) {
                        game.fakeSockets.clientSocket.socketEvents[event.data.type](event.data.data);
                    }
                    break;
            }
        };

        startGameOnWorker();
    }
}

function startGameOnWorker() {
    sendWorkerMessage('startServer', serverConfig);

    game.fakeSockets = {
        worker: {
            sendMessage: (type, data) => {
                sendWorkerMessage('playerEmit', {
                    type: type,
                    data: data
                });
            }
        }
    };

    startPlayScreen(true, true);

    setTimeout(() => {
        game.init();
    }, 1);
}

window.addEventListener('beforeunload', () => {
    if (gameWorker) {
        gameWorker.terminate();
    }
});

function sendWorkerMessage(type, data) {
    gameWorker.postMessage({
        type: type,
        data: data
    });
}

function startSingleplayer(isTutorial, isSandbox) {
    if (!isTutorial && game.services.ad.checkShowVideoAd()) {
        waitingToPlaySingleplayer = {
            isSandbox: isSandbox
        };
        return;
    }

    serverConfig = {
        isSingleplayer: true,
        isTutorial: isTutorial,
        isSandbox: isSandbox,
        skipGameLobby: true,
        isMobile: game.isMobile
    };

    game.clearEntities();

    game.isTutorial = isTutorial;

    if (window.Worker) {
        registerWorker();
    } else {
        let fakeGlobalSocket = {
            to: function() {
                return fakeGlobalSocket;
            },
            emit: function(name, data) {
                if (game.fakeSockets && game.fakeSockets.clientSocket.socketEvents[name]) {
                    game.fakeSockets.clientSocket.socketEvents[name](data);
                }
            },
            sendGlobalMessage: function(name, data) {
                if (game.fakeSockets && game.fakeSockets.clientSocket.socketEvents[name]) {
                    game.fakeSockets.clientSocket.socketEvents[name](data);
                }
            }
        };

        let server = new window.antwarServer.Server(fakeGlobalSocket, 1, () => {}, {}, null, null, serverConfig, window);
        server.startGame();

        game.fakeSockets = {
            serverSocket: {
                connected: true,
                on: function (name, fn) {
                    game.fakeSockets.serverSocket.socketEvents[name] = fn;
                },
                emit: function (name, data) {
                    game.fakeSockets.clientSocket.socketEvents[name](data);
                },
                snapSocket: {
                    client: {
                        conn: {
                            write: function (data) {
                                game.onSnapshot(data.buffer);
                            }
                        }
                    }
                },
                socketEvents: {},
                disconnect: function () {
                    window.location.reload();
                }
            }
        };

        startPlayScreen(true, true);

        setTimeout(() => {
            game.server = server;
            game.init();

            game.fakeSockets.serverSocket.name = 'Player';
            game.fakeSockets.serverSocket.user = {
                isDev: true
            };
            server.onClientConnected(game.fakeSockets.serverSocket);
        }, 1);
    }

    if (isTutorial) {
        game.disableTutorialAsk = true;
        try {
            if (window.localStorage) {
                window.localStorage.setItem('disableTutorialAsk', 'true');
            } else {
                Cookies.set('disableTutorialAsk', game.disableTutorialAsk, {expires: 365});
            }
        } catch (e) {
            Cookies.set('disableTutorialAsk', game.disableTutorialAsk, {expires: 365});
        }
    }

    var eventAction = 'playSingleplayer';
    if (isTutorial) {
        eventAction = 'playTutorial'
    }
    if (isSandbox) {
        eventAction = 'playSandbox'
    }

    if (window.ga) {
        ga('send', {
            hitType: 'event',
            eventCategory: 'Lobby',
            eventAction: eventAction
        });
    }
}
game.startSingleplayer = startSingleplayer;